import _,{ isEmpty } from "lodash";
import moment from "moment";
import { getDisabledHours, getDisabledMinutes } from "../../helpers/date_functions";
import { checkboxColumn } from "../common/columnDefs";
import { alertMessage } from "../../common/Common";
import { convertToKilograms, convertToPounds, renderAlertMessage } from "../../helpers/common";
import AppConfig from "../../config/AppConfig";
import { verifyWhbasedZipCodes } from "../../api/OrdersApi";

export const fromTimeDisabledHours = (data, disabledStartHours) => {
  if (data.start_time || data.item_preference) {
    return getDisabledHours("start_time", disabledStartHours, data);
  }
  return [];
};

export function isEmptyForBoolean (value) {
  if (value === false || value === null)
    return true;
  else
    return false;
}
export const fromTimeDisabledMinutes = (data,
  selectedHour, endHour, endMinute, startHour, startMinute
) => {
  if (data.start_time || data.item_preference) {
    return getDisabledMinutes("start_time", selectedHour, data, endHour, endMinute, startHour, startMinute);
  }
  return [];
};
export const toTimeDisabledHours = (data, disabledEndHours) => {
  if (data.end_time || data.item_preference) {
    return getDisabledHours("end_time", disabledEndHours, data);
  }
  return [];
};

export const toTimeDisabledMinutes = (data,
  selectedHour, startHour, startMinute, endHour, endMinute
) => {
  if (data.end_time || data.item_preference) {
    return getDisabledMinutes("end_time", selectedHour, data, startHour, startMinute, endHour, endMinute);
  }
  return [];
};
export const getWhLocationSlotDetails = (data = [], whLocationCode = '') => {
  // checks for whlocation code and returns the slot details
  if(_.isEmpty(data)) return [];
  if(_.isEmpty(whLocationCode)) return [];
  const filteredWH = data.filter((wh) => wh.location_code === whLocationCode);
  const filteredWhFirstRecord = filteredWH && filteredWH.length ? filteredWH[0] : {};
  if (_.isEmpty(filteredWhFirstRecord.slot_details)) return [];
  return filteredWhFirstRecord.slot_details;
};

export const validateslots = (slotsData = [], isMilitaryTime = false, skipChecks="") => {
    const timeFormat = isMilitaryTime ? 'HH:mm' : 'h:mm A';
    const { errors, slots } = slotsData.reduce(
      (acc, appointment) => {
        // Destructure the appointment object
        const {
          slots,
          appt_date,
          has_expedite,
          has_appointment,
          start_time,
          end_time,
        } = appointment;

        const isApptOrExpediteSelected = Boolean(has_expedite || has_appointment);

        // Check any option is selected or not
        if(isApptOrExpediteSelected || !isEmpty(appt_date) || (slots && slots.length > 0) || !isEmpty(start_time) || !isEmpty(end_time)) {
          // If appointment or expedite is selected, slot is mandatory
          if(isApptOrExpediteSelected || !skipChecks.includes('appt_date')){
            if(!slots || slots.length === 0){
              acc.errors.push('Please select valid slot');
              return acc;
            }
          }

          // Check if appt_date is valid date
          if (!skipChecks.includes('appt_date')) {
            if (!appt_date) { acc.errors.push('Please select valid date'); return acc; }
            const formattedPreference = moment(appt_date).format(
              'YYYY-MM-DD 00:00:00'
            );
            if (!formattedPreference) {
              acc.errors.push('Please select valid date');
              return acc;
            }
          }

          const formattedPreference = appt_date && moment(appt_date).isValid() ? moment(appt_date).format(
            'YYYY-MM-DD 00:00:00'
          ) : null;
          // Check if slots has a valid CUSTOM slot with valid start and end times
          if (slots && slots.includes('CUSTOM')) {
            if (!start_time || !end_time) {
              acc.errors.push('Please select the valid start and end time');
              return acc;
            }

            const formattedStart = moment(
              start_time,
              timeFormat
            ).format('HH:mm');
            const formattedEnd = moment(
              end_time,
              timeFormat
            ).format('HH:mm');
            if (!formattedStart || !formattedEnd || !moment(formattedStart, timeFormat).isValid() || !moment(formattedEnd, timeFormat).isValid()
              || moment(formattedStart).isSameOrAfter(formattedEnd)) {
              acc.errors.push('Please fill valid time slots');
              return acc;
            }

            acc.slots.push({
              ...appointment,
              start_time: formattedStart,
              end_time: formattedEnd,
              appt_date: formattedPreference,
              has_expedite: has_expedite || false,
              has_appointment: has_appointment || false,
            });
          } else {
            const formattedStart = start_time ? moment(
              start_time,
              timeFormat
            ).format('HH:mm') : null;
            const formattedEnd = end_time ? moment(
              end_time,
              timeFormat
            ).format('HH:mm') : null;

            acc.slots.push({
              ...appointment,
              start_time: formattedStart,
              end_time: formattedEnd,
              appt_date: formattedPreference,
              has_expedite: has_expedite || false,
              has_appointment: has_appointment || false,
            });
          }
       }
        return acc;
      },
      { errors: [], slots: [] }
    );
    return { errors, appointments: slots };
  };



export const checkIfOrdershasExceededCreditLimit = (ordersData, creditsExceededAccnts) => {
    const accountCodesWithExceededLimit = creditsExceededAccnts.map(account => account.account_code);
    return ordersData.map((order) => {
      const isLimitExceeded = accountCodesWithExceededLimit.includes(order.account_code);
      return {
        ...order,
        account_limit_exceeded: isLimitExceeded
      };
    }
    );
  };

export const getNonBillableAccountCodes = (accounts = []) => {
  if (!Array.isArray(accounts)) {
    return [];
  }

  return accounts.map((account) => account.code).filter(Boolean);
};

export const isOrderAccountBillable = (account = {}, nonBillableAccounts = []) => {
  if (!Array.isArray(nonBillableAccounts) || nonBillableAccounts.length === 0) {
    return true;
  }

  const accountId = account.account_id || account.id;
  const accountCode = account.account_code || account.code;

  if (!accountId && !accountCode) {
    return true;
  }

  return !nonBillableAccounts.some(
    (nonBillableAccount) =>
      (accountId && nonBillableAccount.id === accountId) ||
      (accountCode && nonBillableAccount.code === accountCode)
  );
};


    // function which takes in the schedule_day_filter and returns the from and to date. 
    export const getFromToDate = (schedule_day_filter , customToDate , customFromDate) => {
      const lastMonthStart = moment().subtract(1, 'month').startOf('month');
      const lastMonthEnd = moment().subtract(1, 'month').endOf('month');
      const lastWeekStart = moment().subtract(1, 'week').startOf('week');
      const lastWeekEnd = moment().subtract(1, 'week').endOf('week');
      const yesterday = moment().subtract(1, 'day');
      const today = moment().startOf('day');
      const tomorrow = moment(today).add(1, 'day');
      const currentWeekStart = moment().startOf('week');
      const currentWeekEnd = moment().endOf('week');
      const currentMonthStart = moment().startOf('month');
      const currentMonthEnd = moment().endOf('month');
      const next3Days = moment().add(2, 'day');
      const next7Days = moment().add(6, 'day');
      const last3Days = moment().subtract(2, 'day');
      const last7Days = moment().subtract(6, 'day');

      switch (schedule_day_filter) {
        case 'Last Month':
          return { fromDate: lastMonthStart, toDate: lastMonthEnd };
        case 'Last Week':
          return { fromDate: lastWeekStart, toDate: lastWeekEnd };
        case 'Yesterday':
          return { fromDate: yesterday, toDate: yesterday };
        case 'Today':
          return { fromDate: today, toDate: today };
        case 'Tomorrow':
          return { fromDate: tomorrow, toDate: tomorrow };
        case 'Today & Tomorrow':
          return { fromDate: today, toDate: tomorrow };
        case 'Yesterday & Today':
          return { fromDate: yesterday, toDate: today };
        case 'Last 3 Days':
        case 'Last 3':
          return { fromDate: last3Days, toDate: today };
        case 'Last 7 Days':
        case 'Last 7':
          return { fromDate: last7Days, toDate: today };
        case 'Current Week':
          return { fromDate: currentWeekStart, toDate: currentWeekEnd };
        case 'Next 3 Days':
        case 'Next 3':
          return { fromDate: today, toDate: next3Days };
        case 'Next 7 Days':
        case 'Next 7':
          return { fromDate: today, toDate: next7Days };
        case 'Current Month':
          return { fromDate: currentMonthStart, toDate: currentMonthEnd };
        case 'Custom':
          const fromDate = moment(customFromDate, "YYYY-MM-DD HH:mm:ss Z");
          const toDate = moment(customToDate, "YYYY-MM-DD HH:mm:ss Z");
          return { fromDate, toDate };
        default:
          return { fromDate: today, toDate: today };
      }
    }

export const getTimeFrameTitle = (fromDate, toDate) => {
  const today = moment().startOf('day');
  const isBetween = (date, start, end) => date.isBetween(start, end, null, '[]');
  const isSameDay = (date1, date2) => date1.isSame(date2, 'day');

  const timeFrames = {
    'Today': () => isSameDay(fromDate, today) && isSameDay(toDate, today),
    'Tomorrow': () => isSameDay(fromDate, today.clone().add(1, 'day')) && isSameDay(toDate, today.clone().add(1, 'day')),
    'Yesterday': () => isSameDay(fromDate, today.clone().subtract(1, 'day')) && isSameDay(toDate, today.clone().subtract(1, 'day')),
    'Today & Tomorrow': () => isSameDay(fromDate, today) && isSameDay(toDate, today.clone().add(1, 'day')),
    'Yesterday & Today': () => isSameDay(fromDate, today.clone().subtract(1, 'day')) && isSameDay(toDate, today),
    'Last 3 Days': () => isSameDay(fromDate, today.clone().subtract(2, 'day')) && isSameDay(toDate, today),
    'Last 7 Days': () => isSameDay(fromDate, today.clone().subtract(6, 'day')) && isSameDay(toDate, today),
    'Next 3 Days': () => isSameDay(fromDate, today) && isSameDay(toDate, today.clone().add(2, 'day')),
    'Next 7 Days': () => isSameDay(fromDate, today) && isSameDay(toDate, today.clone().add(6, 'day')),
    'Last Month': () => isBetween(fromDate, today.clone().subtract(1, 'month').startOf('month'), today.clone().subtract(1, 'month').endOf('month')) &&
      isBetween(toDate, today.clone().subtract(1, 'month').startOf('month'), today.clone().subtract(1, 'month').endOf('month')),
    'Last Week': () => isBetween(fromDate, today.clone().subtract(1, 'week').startOf('week'), today.clone().subtract(1, 'week').endOf('week')) &&
      isBetween(toDate, today.clone().subtract(1, 'week').startOf('week'), today.clone().subtract(1, 'week').endOf('week')),
    'Current Month': () => moment().isSame(fromDate, 'month') && moment().isSame(toDate, 'month') &&
    fromDate.isSame(moment().startOf('month'), 'day') &&
    toDate.isSame(moment().endOf('month'), 'day'),
    'Current Week': () => moment().isSame(fromDate, 'week') && moment().isSame(toDate, 'week') &&
    fromDate.isSame(moment().startOf('week'), 'day') &&
    toDate.isSame(moment().endOf('week'), 'day'),
  };

  for (let [ title, condition ] of Object.entries(timeFrames)) {
    if (condition()) return title;
  }

  return 'Custom';
};


  export const getStoredColumns = (currentUser, tableName) => {
    const savedWidths = _.get(currentUser, `column_widths.${tableName}`, {});
    return Object.keys(savedWidths).map((key) => {
      return {
        key,
        width: savedWidths[ key ],
      };
    });
  };
  
  export const isColumnVisibleByDefault = (col) => col?.defaultHidden !== true;

  export const getConfiguredColumns = (
    currentCols,
    storedColumns,
    userConfiguration,
    orgConfiguration,
    tableName
  ) => {
    const columns = [];
    const leftFixedColumns = [];
    const rightFixedColumns = [];
    const savedGridList =
      userConfiguration[tableName] || orgConfiguration[tableName];

    if (typeof savedGridList !== "undefined" && Array.isArray(savedGridList)) {
      savedGridList.forEach((column) => {
        const foundColumn = currentCols.find((col) => col.field === column);
        if (foundColumn) {
          const storedWidth = storedColumns.find((col) => col.key === column);
          const columnConfig = { ...foundColumn };
          // Apply stored width and remove flex if stored width exists.
          // Skip non-resizable columns (e.g. the pinned actions column): they
          // can't be user-resized, so any "saved" width is stale and would
          // clobber their computed def width.
          if (storedWidth && foundColumn.resizable !== false) {
            columnConfig.width = storedWidth.width;
            delete columnConfig.flex;
          }
          // If no stored width but column has a fixed width (not flex), keep it
          // If column has flex, it will be preserved for auto-sizing
          columns.push(columnConfig);
        }
      });
    } else {
      // No saved grid list - show default-visible columns only (skip opt-in cols)
      currentCols.filter(isColumnVisibleByDefault).forEach((col) => {
        const storedWidth = storedColumns.find((sc) => sc.key === col.field);
        const columnConfig = { ...col };
        if (storedWidth && col.resizable !== false) {
          columnConfig.width = storedWidth.width;
          delete columnConfig.flex;
        }
        columns.push(columnConfig);
      });
    }

    if (!columns.some((col) => col.pinned === "left")) {
      const checkBoxIncluded = currentCols.filter(
        (col) => col.pinned === "left"
      );
      if (checkBoxIncluded.length) {
        leftFixedColumns.push(...checkBoxIncluded);
      }
    }
    if (!columns.some((col) => col.pinned === "right")) {
      const actionsColumnIncluded = currentCols.filter(
        (col) => col.pinned === "right"
      );
      if (actionsColumnIncluded.length) {
        rightFixedColumns.push(...actionsColumnIncluded);
      }
    }
    return [...leftFixedColumns, ...columns, ...rightFixedColumns];
  };

  export const isLegLevelAssignEnabled = (organizationSettings = {}) =>
    organizationSettings?.order_assign_without_restriction === "true" ||
    organizationSettings?.order_assign_without_restriction === true;

  export const ensureLegLevelColumns = (columns, allCols, organizationSettings = {}) => {
    if (!isLegLevelAssignEnabled(organizationSettings)) {
      return columns;
    }

    const ORDER_NO_FIELD = "customer_order_number";
    const legFields = ["pickup_leg", "delivery_leg"];
    const priorityFields = [ORDER_NO_FIELD, ...legFields];

    const findCol = (field) =>
      columns.find((col) => col.field === field) ||
      allCols.find((col) => col.field === field);

    const markVisible = (col) => (col ? { ...col, isVisible: true } : null);

    const orderNoCol = markVisible(findCol(ORDER_NO_FIELD));
    const pickupCol = markVisible(findCol("pickup_leg"));
    const deliveryCol = markVisible(findCol("delivery_leg"));

    if (!pickupCol || !deliveryCol) {
      return columns;
    }

    const reserved = new Set([...priorityFields, "0", "leg_row_checkbox"]);
    const leftFixed = columns.filter(
      (col) =>
        col.pinned === "left" &&
        col.field !== "0" &&
        !reserved.has(col.field)
    );
    const rightFixed = columns.filter((col) => col.pinned === "right");
    const legCheckboxCol =
      columns.find((col) => col.field === "leg_row_checkbox") ||
      allCols.find((col) => col.field === "leg_row_checkbox");
    const checkboxCol =
      columns.find((col) => col.field === "0") ||
      allCols.find((col) => col.field === "0");
    const middle = columns.filter(
      (col) =>
        !reserved.has(col.field) &&
        col.pinned !== "left" &&
        col.pinned !== "right"
    );

    const leading = legCheckboxCol ? [legCheckboxCol] : (checkboxCol ? [checkboxCol] : []);
    const priorityCols = [orderNoCol, pickupCol, deliveryCol].filter(Boolean);

    return [...leading, ...leftFixed, ...priorityCols, ...middle, ...rightFixed];
  };


export function magicMinutes(minutes) {
  if (minutes < 0) {
    return "Invalid input: Please provide a non-negative number of minutes.";
  }

  let duration = moment.duration(minutes, 'minutes');
  let result = [];

  const years = Math.floor(duration.asYears());
  const months = Math.floor(duration.asMonths() % 12);
  const weeks = Math.floor(duration.asWeeks() % 4.345);
  const days = Math.floor(duration.asDays() % 7);
  const hours = Math.floor(duration.asHours() % 24);
  const minutesLeft = Math.floor(duration.asMinutes() % 60);

  if (years > 0) {
    result.push(`${years} year${years > 1 ? 's' : ''}`);
  }
  if (months > 0) {
    result.push(`${months} month${months > 1 ? 's' : ''}`);
  }
  if (weeks > 0) {
    result.push(`${weeks} week${weeks > 1 ? 's' : ''}`);
  }
  if (days > 0) {
    result.push(`${days} day${days > 1 ? 's' : ''}`);
  }
  if (hours > 0) {
    result.push(`${hours} hour${hours > 1 ? 's' : ''}`);
  }
  if (minutesLeft > 0) {
    result.push(`${minutesLeft} minute${minutesLeft > 1 ? 's' : ''}`);
  }

  return result.join(' ');
} 

export const validateBulkActions = (
  records = [],
  action = "",
  cb = null,
  errorCallback = null,
  isIncludes = true,
) => {
  const checkValidation = (allowedStatuses) => {
    return isIncludes ? 
    records.filter((rec) => !allowedStatuses.includes(rec.status)).map(rec => rec.customer_order_number) : 
    records.filter((rec) => allowedStatuses.includes(rec.status)).map(rec => rec.customer_order_number)
  }
  if(!isEmpty(action)){
    let result = []
    switch(action){
      case 'SCHEDULE': result =  checkValidation(["NEW", "RECEIVED", "VERIFIED", "ON_HOLD", "ON_HAND"]); break;
      case 'MOVE_TO_RECEIVED':  result = checkValidation(["NEW"]); break;
      case 'QUICK_DISPATCH':  result = checkValidation(["NEW", "RECEIVED", "VERIFIED", "ON_HAND"]); break;
      case 'MOVE_TO_VERIFY':  result = checkValidation(["RECEIVED"]); break;
      case 'CHANGE_STATUS':  result = checkValidation(["PENDING", "REJECTED"]); break;
      case 'PRINT_LABELS':  result = checkValidation(["PENDING", "REJECTED"]); break;
      case 'CLONE_ORDERS':  result = checkValidation(["NEW", "RECEIVED", "VERIFIED", "ON_HOLD"]); break;
      case 'LINEHAUL':  result = checkValidation(["NEW", "RECEIVED", "VERIFIED"]); break;
      case 'SWITCH_ORDERS':  result = checkValidation(["NEW", "RECEIVED", "VERIFIED"]); break;
      case 'BULK_DELETE':  result = checkValidation([
        "NEW",
        "RECEIVED",
        "VERIFIED",
        "PENDING",
        "APPROVED",
        "REJECTED",
        "ON_HOLD",
      ]) ; break;
      default:  break
    }
    if(result.length === 0){
      cb();
    } else {
      if(errorCallback){
        errorCallback(result)
      } else {
        renderAlertMessage(`${result.join(',')} are not allowed`)
      }
    }
  }
  
};
export const getEnvironment = () => {
  const hostname = window.location.hostname;
  const env = hostname.split('.')[ 0 ];

  return env;
}

export const displayWeightUnits = (weight, accountWeightUnits, account_code, singleUnit = false) => {
  if (!weight) return '';

  // Get account's preferred unit, default to 'lbs' if not specified
  const preferredUnit = accountWeightUnits?.[ account_code ] || 'lbs';

  // Convert weight based on preferred unit
  let formattedWeight;
  if (preferredUnit === 'kgs') {
    const kgs = parseFloat(weight);
    const lbs = convertToPounds(kgs, false); // Convert kgs to lbs
    formattedWeight = singleUnit
      ? `${parseFloat(kgs.toFixed(2))} kg`
      : `${parseFloat(lbs.toFixed(2))} lbs / ${parseFloat(kgs.toFixed(2))} kg`;
  } else {
    const lbs = parseFloat(weight);
    const kgs = convertToKilograms(lbs, false); // Convert lbs to kgs
    formattedWeight = singleUnit
      ? `${parseFloat(lbs.toFixed(2))} lbs`
      : `${parseFloat(lbs.toFixed(2))} lbs / ${parseFloat(kgs.toFixed(2))} kg`;
  }

  return `${formattedWeight}`;
};


export const sortedMsOrders = (data) => {
  // Step 1: Separate MS and non-MS orders
  const msOrders = data.filter(item => item.type_of_order === "MS");
  const nonMsOrders = data.filter(item => item.type_of_order !== "MS");

  // Step 2: Group MS orders by customer_order_number with safety checks
  const groupedOrders = msOrders.reduce((acc, order) => {
    const customerOrderNumber = order.customer_order_number || "UNKNOWN"; // Handle missing customer_order_number
    if (!acc[customerOrderNumber]) {
      acc[customerOrderNumber] = [];
    }
    acc[customerOrderNumber].push(order);
    return acc;
  }, {});

  // Step 3: Sort each group by loc_order_sequence with safety check for null/undefined loc_order_sequence
  Object.keys(groupedOrders).forEach(key => {
    groupedOrders[key].sort((a, b) => (a.loc_order_sequence || 0) - (b.loc_order_sequence || 0));
  });

  // Step 4: Flatten the groups back into an array
  const sortedMsOrders = Object.values(groupedOrders).flat();

  // Step 5: Combine non-MS orders and sorted MS orders
  const finalSortedData = [...nonMsOrders, ...sortedMsOrders];

  // Optional: Log final output for verification
  return finalSortedData;
};

export function getCommaSeparatedAddress(addressObj) {
  const {
    address_line1,
    address_line2,
    city,
    state,
    zipcode,
    country
  } = addressObj;

  return [
    address_line1,
    address_line2,
    city,
    state,
    country,
    zipcode
  ]
    .map(val => val?.trim?.()) // trim strings if possible
    .filter(Boolean)
    .join(', ');
}

export function getDispatchColorObject(currentOrder) {
  const tags = currentOrder?.tags?.map((tag) => tag.toLowerCase().replace(/\s+/g, "_")) || [];
  const isBondedArea = tags?.includes("cfs_bonded");
  const dispatchColorObj = isBondedArea ? { ...AppConfig.cfs_bonded_color_tag } : _.get(currentOrder, 'color_tags[0]', null);
  return dispatchColorObj;
}

export const generalizedverifyWarehouseZipCodes = async ({
  orgId,
  zipcode,
  warehouseId,
  typeOfLoc,
  orderTypeCode
}) => {
  if (orderTypeCode !== "PLHD") return null;
  // if (!zipcode || zipcode.length < 5) return null;

  const result = await verifyWhbasedZipCodes(orgId, zipcode, warehouseId, typeOfLoc);


  if (!result?.success) return null;

  const warning = result?.data?.warning;
  const warehouses = result?.data?.warehouses || [];
  const renderActions = result?.data?.add_zip_to_warehouse;
  const warningText = result?.data?.warning;

  // ✅ Return whenever there's meaningful data, not just when warning exists
  if (warning || warehouses.length > 0 || renderActions) {
    return {
      warning,
      warehouses,
      renderActions,
      warningText
    };
  }

  return null;
};

export function validateCompanyName(locationData) {
  const locData = locationData
    .filter(item => item?.customer_address_line_1 && !item.company_name?.trim())
    .map(item => `${item.type_of_loc ? `${item.type_of_loc} - ` : ""} company name is required`);
  return locData;
}
